import QuestionsTab from './QuestionsTab';

export default QuestionsTab;
